module.exports = __webpack_public_path__ + "question_ico@2x.590b7aaad2bf081c089b428d6f935a01.png";